import AuthLayout from '../../components/auth/AuthLayout';
import { LoginForm } from '../../components/auth/LoginForm';

const LoginPage = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage; 